module.exports = __webpack_public_path__ + "img/rep.158d4cbb.svg";